module.exports = {"640422100":"吉强镇","640422101":"兴隆镇","640422102":"平峰镇","640422200":"新营乡","640422201":"红耀乡","640422202":"田坪乡","640422203":"马建乡","640422204":"震湖乡","640422205":"兴平乡","640422206":"西滩乡","640422207":"王民乡","640422208":"什字乡","640422209":"马莲乡","640422210":"将台乡","640422211":"硝河乡","640422212":"偏城乡","640422213":"沙沟乡","640422214":"白崖乡","640422215":"火石寨乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/640422.json
// module id = 2827
// module chunks = 0